import { FILTER_NAMES } from "../../filters";

export const CLIENT_CONFIG_DEFAULT_WIDGET_OPTIONS = {
  base: {
    proposition: {
      filters: {
        secondaryFilters: [
          FILTER_NAMES.monthlyFee,
          FILTER_NAMES.providers,
          FILTER_NAMES.currentProvider,
          { name: FILTER_NAMES.offerExtraGroups, order: [] },
          FILTER_NAMES.contractTermInMonths,
          FILTER_NAMES.dataSpeedGen
        ]
      },
      initialFilter: {
        minDataCredits: 10000,
        dataSpeedGen: [4, 5]
      }
    },
    simOnly: {
      filters: {
        secondaryFilters: [
          FILTER_NAMES.providers,
          FILTER_NAMES.currentProvider,
          { name: FILTER_NAMES.offerExtraGroups, order: [] },
          FILTER_NAMES.contractTermInMonths,
          FILTER_NAMES.dataSpeedGen
        ]
      },
      initialFilter: {
        dataSpeedGen: [4, 5]
      }
    }
  }
};
